import { Component, Input } from '@angular/core';
import { IonicPage, NavParams, Item } from 'ionic-angular';

import { ViewController } from 'ionic-angular';
import { NormalReportService } from '../../services/normalreport.service';
import { OrderDetailModel } from '../../models/orderdetail.model';
import { BettingService } from '../../services/betting.service';
import { AlertService } from '../../providers/alert.service';
import { FixedExtend } from '../../config/fixed-extend';
/**
 * 
 * 注单续投
 * 
 */
@IonicPage()
@Component({
    selector: 'page-continue',
    templateUrl: 'continue.html',
})
export class ContinuePage {
    onlyValue: any;
     order: OrderDetailModel = new OrderDetailModel();
    // 倍数
    Multiple = 1;
    parameter;
    bettingInfoIssues;
    brickContent: string = "";
    resumeNo: string = '';
    // 倒计时
    remainTime: any;
    bettingMoneyCount;
    issueinfo;
    changeBettingMoney;
    constructor(
        private viewCtrl: ViewController,
        private navpar: NavParams,
        private normalreport: NormalReportService,
        private bettingService: BettingService,
        private alert: AlertService,
        private indexExtend: FixedExtend
    ) {
        this.onlyValue = this.navpar.data.report;
        console.log(".....", this.onlyValue);
    }

    ionViewDidLoad(){
        this.normalreport.getOrderDetail(this.onlyValue.BettingID).then(s => {
            this.order = s;
            console.log("..............", this.order);
            // if(this.order.Issues){
            //     this.issueinfo = this.order.Issues[0];
            //     console.log("111",this.issueinfo);
            // }
            this.changeBettingMoney = this.indexExtend.accMul(
                this.indexExtend.accDiv(
                  this.order.BettingMoney,
                  this.onlyValue.Multiple
                ),
                this.Multiple
              );
            this.bettingService.getIssue(this.order.LotteryCode).then(res => {
                console.log("ssssssssssss",s)
                this.resumeNo = res.CurrentIssueNo;
                this.remainTime = res.RemainTime/1000;
                let set = setInterval(() => {
                    this.remainTime--;
                    if (this.remainTime == 0) {
                        clearInterval(set)
                    }
                }, 1000);
                    this.parameter = {
                        BettingMoney: this.indexExtend.accMul(
                            this.indexExtend.accDiv(
                              this.order.BettingMoney,
                              this.onlyValue.Multiple
                            ),
                            this.Multiple
                          ),
                        BettingNumber: this.order.BettingNumber,
                        BuyIssueCount: this.order.BuyIssueCount,
                        GraduationCount: this.order.GraduationCount,
                        IsChaseNo: false,
                        IssueNo: this.resumeNo,
                        LotteryCode: this.order.LotteryCode,
                        LotteryPlayDetailCode: this.order.PlayCode,
                        Multiple: this.Multiple,
                        RuleName: this.order.PlayName,
                        SelectMedian: this.order.SelectMedian,
                        BettingInfoIssueList: [
                            {
                                IssueNo: this.resumeNo,
                                Multiple: s.Issues[0].Multiple,
                                PerPrice: s.Issues[0].PerPrice
                            }
                        ]
                    }
            })
        })
    }

    getSubmitBetting() {
        console.log("------------------------------")
            // this.parameter.BettingMoney = this.order.BettingMoney / this.onlyValue.Multiple * this.Multiple;
            this.parameter.BettingMoney = this.indexExtend.accMul(this.indexExtend.accDiv(this.order.BettingMoney,this.onlyValue.Multiple),this.Multiple);
                this.parameter.BettingInfoIssueList[0].Multiple = this.Multiple;
            this.parameter.Multiple = this.Multiple;
            this.bettingService.betting(this.parameter).then(res => {
                if (res) {
                    this.dismiss();
                    this.alert.showAlert(res.Error);
                } else {
                    this.alert.showAlert(res.Error);
                }
            })
    }

    // 倍数自减
    subtract() {
        if (this.Multiple > 1) {
            this.Multiple--;
            this.changeBettingMoney = this.indexExtend.accMul(
                this.indexExtend.accDiv(
                  this.order.BettingMoney,
                  this.onlyValue.Multiple
                ),
                this.Multiple
              );
        } else {
            this.Multiple = 1;
            this.changeBettingMoney = this.indexExtend.accMul(
                this.indexExtend.accDiv(
                  this.order.BettingMoney,
                  this.onlyValue.Multiple
                ),
                this.Multiple
              );
        }
    }
    add() {
        this.Multiple++;
        this.changeBettingMoney = this.indexExtend.accMul(
            this.indexExtend.accDiv(this.order.BettingMoney, this.onlyValue.Multiple),
            this.Multiple
          );
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    changeMultiple(ev) {
        if (ev) {
          this.changeBettingMoney = this.indexExtend.accMul(
            this.indexExtend.accDiv(
              this.order.BettingMoney,
              this.onlyValue.Multiple
            ),
            ev
          );
        } else {
          this.Multiple = 1;
        }
      }

}



// WEBPACK FOOTER //
// ./src/pages/normalreport/continue.ts